<script setup lang="ts">
import { twMerge } from 'tailwind-merge'
</script>

<template>
  <div
    :class="
      twMerge('flex min-h-7 min-w-0 flex-row items-center py-1 pr-1', String($attrs.class || ''))
    "
  >
    <slot />
  </div>
</template>
